/**
 * STICKY ADD-TO-CART BAR
 * Watches the real add-to-cart button; once it scrolls out of view, the
 * sticky bar "pours" up from the bottom. Its own button submits the real
 * product form directly (via the `form` HTML attribute), so quantity,
 * selected variant, and Dawn's own AJAX submit handling are all inherited
 * rather than duplicated here.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var anchorId = bar.dataset.anchorId;
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    if (!anchor || !('IntersectionObserver' in window)) return;

    function show() {
      if (bar.classList.contains('is-visible')) return;
      bar.classList.add('is-visible');
      bar.removeAttribute('aria-hidden');
      bar.removeAttribute('inert');
    }

    function hide() {
      if (!bar.classList.contains('is-visible')) return;
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hide();
          } else if (entry.boundingClientRect.top < 0) {
            // Only reveal once scrolled PAST the real button, not before
            // it has appeared on the way down the page.
            show();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    // Keep the mirrored price in sync with whatever variant is actually
    // selected — read from the real, already-updated price on the page
    // rather than re-implementing variant price lookup here.
    var priceEl = bar.querySelector('[data-sticky-price]');
    function syncPrice() {
      // Sale price (a <span>) takes priority over the struck-through
      // regular price (an <s>) when both are present.
      var sourcePrice =
        document.querySelector('.product .price .price-item--sale') ||
        document.querySelector('.product .price .price-item--regular');
      if (priceEl && sourcePrice && sourcePrice.textContent.trim()) {
        priceEl.textContent = sourcePrice.textContent.trim();
      }
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.optionValueSelectionChange) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        setTimeout(syncPrice, 350); // after the section's AJAX re-render lands
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
